import { wrapMiddlewaresWithSentry } from '@sentry/tanstackstart-react';
import {
  sentryGlobalFunctionMiddleware,
  sentryGlobalRequestMiddleware,
} from '@sentry/tanstackstart-react';
import { createCsrfMiddleware, createStart } from '@tanstack/react-start';

import { canonicalRequestMiddleware } from '@/middleware/canonical-request';

const csrfMiddleware = createCsrfMiddleware({
  filter: (context) => context.handlerType === 'serverFn',
});

export const startInstance = createStart(() => ({
  requestMiddleware: wrapMiddlewaresWithSentry({ canonicalRequestMiddleware, sentryGlobalRequestMiddleware, csrfMiddleware }),
  functionMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalFunctionMiddleware }),
}));
